// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { Flex } from '@finect/tabular-core/Flex';
import { Button } from '@finect/tabular-core/Button';
import { Small } from '@finect/tabular-core/Small';
import { Hero, HeroContent, HeroText, HeroCTA } from './partials';
import hero from './assets/hero.webp';
import heroTablet from './assets/hero-tablet.webp';
import heroMobile from './assets/hero-mobile.webp';

type Props = {
  toggleModal: Function
};

export const HeroLanding = ({ toggleModal }: Props) => (
  <Hero>
    <picture>
      <source media="(max-width: 500px)" srcSet={heroMobile} type="image/webp" />
      <source media="(max-width: 900px)" srcSet={heroTablet} type="image/webp" />
      {/* Imagen LCP: eager (NO lazy, está en el viewport inicial) + fetchpriority alta */}
      <img
        className="hero-bg"
        src={hero}
        alt="Velero navegando en mar abierto"
        // eslint-disable-next-line react/no-unknown-property
        fetchpriority="high"
        decoding="async"
      />
    </picture>
    <HeroContent>
      <HeroText>
        <h1>Encuentra un <b>asesor financiero</b> y saca el máximo partido a tu dinero.</h1>
        <p>
          Planifica tu futuro financiero, rentabiliza tus ahorros y evita errores con la ayuda de un{' '}
          <b>asesor de inversiones</b> que se adapte a tus objetivos. Encuentra tu{' '}
          <b>asesor financiero online</b> o cerca de ti.
        </p>
      </HeroText>
      <HeroCTA>
        <Small display="block" textAlign="center" margin="0 0 6px">
          Esta búsqueda es 100% gratuita
        </Small>
        <Button secondary onClick={() => toggleModal()}>
          Busca un asesor financiero
        </Button>
        <Flex align="center" justify="center">
          {/* <Link to="/asesores/ayuda/como-ayudar" data-fi-event="home-asesoresHero">
            Cómo te ayuda un experto financiero
          </Link> */}
          <Link to="/asesores/saber/cuanto-cuesta" data-fi-event="home-asesoresHero">
            Cuánto cuesta un asesor financiero
          </Link>
        </Flex>
      </HeroCTA>
    </HeroContent>
  </Hero>
);
